import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ImageGallery from "react-image-gallery";

const PropertyContentGallery: React.FC<{ images: any[] }> = ({ images }) => {
  return (<>
    {images && (
      <Container>
        <Row className="justify-content-center">
          <Col xs={10}>
            <ImageGallery items={images} />
          </Col>
        </Row>
      </Container>
    )}
  </>);
};

export default PropertyContentGallery;
